var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSource2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 2.667,
    fill: "#000",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 15.5,
    height: 15.5,
    rx: 2.417,
    stroke: "#000",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.677 11.666V10.64l2.964-3.708c.114-.15.192-.288.234-.417.028-.121.042-.236.042-.343 0-.285-.089-.533-.266-.745-.184-.212-.444-.321-.781-.328a1.03 1.03 0 00-.745.286c-.205.191-.326.46-.365.808H5.677c.028-.632.24-1.155.635-1.568.4-.403.891-.608 1.474-.615.653.007 1.183.216 1.589.625.413.407.623.922.63 1.547 0 .5-.153.945-.458 1.333l-2.443 3.063h2.901v1.088H5.677z",
    fill: "#000",
    fillOpacity: 0.6
  })));
}
export default SvgSource2;